/**
 * ARAM Platform - Mobile Layout (no sidebar)
 * Used for handheld RFID scanner pages (Chafon H105, etc.)
 */

import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuthStore } from '@/stores/authStore'

export function MobileLayout() {
  const { isAuthenticated, isLoading } = useAuthStore()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
      </div>
    )
  }

  // Microapp WMS (Hito 1 demo): permite ingreso directo para pruebas en handheld
  if (!isAuthenticated && !location.pathname.startsWith('/mobile/wms')) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Outlet />
    </div>
  )
}
